import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { StyledSvgIcon } from './SvgIcon.styles.js';
const _excluded = ["children", "classes", "fontSize", "viewBox", "width", "height", "sx"];
const SvgIcon = _ref => {
  let {
      children,
      classes,
      fontSize,
      viewBox,
      width,
      height,
      sx
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledSvgIcon, _extends({
    classes: classes,
    size: fontSize,
    fontSize: fontSize,
    viewBox: viewBox,
    width: width,
    height: height,
    sx: _objectSpread2({
      width: width,
      height: height
    }, sx)
  }, otherProps), children);
};
SvgIcon.propTypes = {
  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component. <a>See CSS</a> API below for more details.
   */
  classes: PropTypes.shape({}),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * 'inherit'| 'large'| 'medium'| 'small'| string
   * string type for Material v5.0 support
   */
  fontSize: PropTypes.string,
  // https://mui.com/material-ui/api/svg-icon/
  viewBox: PropTypes.string
};
SvgIcon.defaultProps = {
  children: null,
  fontSize: "large",
  width: 32,
  height: 32,
  viewBox: "0 0 20 20"
};
export { SvgIcon as default };
//# sourceMappingURL=SvgIcon.js.map